import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  ACTIVITY_AGENCY_INCIDENT,
  CLEAR_AGENCY_INCIDENTS,
  FLAG_GETTING_AGENCY_INCIDENTS,
  GET_AGENCY_INCIDENTS,
} from '../../../actions/types/supervision-control/AgencyIncident';

const INITIAL_STATE = Immutable.Map({
  agencyIncidents: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  agencyIncidentActivity: Immutable.Map({
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_AGENCY_INCIDENTS:
      return state.setIn(['agencyIncidents', 'loading'], action.payload);
    case GET_AGENCY_INCIDENTS:
      return state.setIn(
        ['agencyIncidents', 'content'],
        Immutable.Map(action.payload),
      );
    case CLEAR_AGENCY_INCIDENTS:
      return state.setIn(['agencyIncidents', 'content'], Immutable.Map(COLLECTION_SHAPE));
    case ACTIVITY_AGENCY_INCIDENT:
      return state.setIn(['agencyIncidentActivity', 'loading'], action.payload);
    default:
      return state;
  }
};
